import { render, staticRenderFns } from "./AlarmeLevelParametersTable.vue?vue&type=template&id=2b71ae0e&scoped=true&"
import script from "./AlarmeLevelParametersTable.vue?vue&type=script&lang=js&"
export * from "./AlarmeLevelParametersTable.vue?vue&type=script&lang=js&"
import style0 from "./AlarmeLevelParametersTable.vue?vue&type=style&index=0&id=2b71ae0e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b71ae0e",
  null
  
)

export default component.exports